export enum ClientEventType {
  PAGE_VIEW = "PAGE_VIEW",
  BUTTON_CLICK = "BUTTON_CLICK",
  PERMISSION_CHECK = "PERMISSION_CHECK",
  PERMISSION_DENIED = "PERMISSION_DENIED",
  NAVIGATION = "NAVIGATION",
  ERROR = "ERROR",
}

export interface ClientLogEntry {
  eventType: ClientEventType;
  timestamp: string;
  username: string;
  metadata: Record<string, unknown>;
}
